import React, { useEffect, useState } from "react";

const links = [
    { id: "chiffres", label: "Chiffres" },
    { id: "experiences", label: "Expériences" },
    { id: "etudes", label: "Études de cas" },
    { id: "clients", label: "Clients" },
    { id: "competences", label: "Compétences" },
    { id: "contact", label: "Contact" },
];

export default function Nav() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="nav-header"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "bg-[#f7f5f1]/85 backdrop-blur-md border-b border-[#e8e4dd]"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-20 flex items-center justify-between">
                <a
                    href="#top"
                    data-testid="nav-logo"
                    className="flex items-baseline gap-2 group"
                >
                    <span className="font-serif italic text-2xl text-[#0e0e0c]">
                        Lionel
                    </span>
                    <span className="font-serif text-2xl font-medium text-[#0e0e0c]">
                        Soulton
                    </span>
                </a>

                <nav className="hidden lg:flex items-center gap-9">
                    {links.map((l) => (
                        <a
                            key={l.id}
                            href={`#${l.id}`}
                            data-testid={`nav-link-${l.id}`}
                            className="text-[13px] text-[#2c2c2a] hover:text-[#0e0e0c] transition-colors tracking-wide"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <a
                    href="mailto:quentinsoulton@gmail.com"
                    data-testid="nav-cta-mail"
                    className="btn-primary"
                >
                    Me contacter
                </a>
            </div>
        </header>
    );
}
